<template>
  <div>
    <ToastMessages />
    <RouterView />
  </div>
</template>

<style lang="scss">
@import "./assets/style/all.scss";
</style>
